import { __assign } from "tslib";
export var composeMapper = function () {
    return function (originalMapper, _a, mapperFunc) {
        var add = _a.add, remove = _a.remove;
        var originalDeps = remove
            ? Object.keys(originalMapper.deps).filter(function (dependency) { return !remove.includes(dependency); })
            : Object.keys(originalMapper.deps);
        var mergedDeps = add ? originalDeps.concat(add) : originalDeps;
        var deps = mergedDeps.reduce(function (acc, key) {
            var _a;
            return (__assign(__assign({}, acc), (_a = {}, _a[key] = true, _a)));
        }, {});
        var resolver = function (data, carmiData) { return mapperFunc(originalMapper.resolver, data, carmiData); };
        return {
            deps: deps,
            resolver: resolver,
        };
    };
};
//# sourceMappingURL=composeMapper.js.map